import request from '@/utils/request'

export function updateMailCfg(data) {
  return request({
    url: 'api/v1/mail/updateMail',
    method: 'post',
    data: data
  })
}

export function getMailCfgList(data) {
  return request({
    url: 'api/v1/level/getLevelCfg',
    method: 'get',
    params: data
  })
}

